module.exports = __webpack_public_path__ + "static/media/dolby.b6ca9eab.svg";